const handledErrors = new WeakSet<object>();

export function markErrorAsHandled(error: unknown): void {
  if (error && typeof error === "object") {
    handledErrors.add(error);
  }
}

export function isErrorHandled(error: unknown): boolean {
  return (
    error !== null && typeof error === "object" && handledErrors.has(error)
  );
}
